// App-level DOM that exists in every state: the landscape guard. Screens
// (start, error) and the picker mount into #app as siblings of the canvas.
import { t, onLanguageChange } from '../i18n/index.js';

export function createShell(app) {
  const landscape = document.createElement('div');
  landscape.className = 'mw-landscape';
  const render = () => {
    landscape.textContent = t('portrait.turn');
  };
  render();
  onLanguageChange(render);
  app.append(landscape);
  return { app, landscape };
}
